'use strict';

import {Component, Inject, Input, OnInit} from 'ng-metadata/core';
import {IStateParamsService} from 'angular-ui-router';


import {LoginService} from './login.service';
//your imports go here
import {AuthenticationMethod} from '../../appConfig/appConfigForward';
import {UsernamePasswordLoginService} from '../usernamePasswordLogin.service';
import {JwtUtilService} from '../jwtUtil.service';
import {LoginHelpService} from './loginHelp/loginHelp.service';
import {STATE_NAMES} from '../../primoExplore/primoExploreStates.module';
import {PersonalizeResultsButtonService} from "../../search/personalization/personalizationButton/personalizeResultsButton.service";


@Component({
    selector: 'prm-login',
    templateUrl: 'components/security/login/login.html',
})


export class PrmLogin implements OnInit {
    @Input() private authenticationMethods: AuthenticationMethod[];
    @Input() private isStandAlone: boolean;

    private _selectedTab: number = 0;
    private _showSubmitButton: boolean = false;
    private showActionsBar: boolean = false;
    private _showBackButton: boolean = false;
    private _isDualLogin: boolean = false;
    private _selectedAuthenticationMethod: AuthenticationMethod;
    private password: string;
    private username: string;
    private _errorLabel: string = '';
    private _errorField: string = '';
    private KEY_CODE = {
        ESCAPE: 27,
    };

    constructor(private loginService: LoginService,
                @Inject('$mdDialog') private $mdDialog: ng.material.IDialogService,
                @Inject('loginIcons') public loginIcons,
                private jwtUtilService: JwtUtilService,
                private personalizeResultsButtonService: PersonalizeResultsButtonService,
                @Inject('I18nService') private i18nService,
                @Inject('$state') private $state: ng.ui.IStateService,
                @Inject('$stateParams') private $stateParams: IStateParamsService,
                private usernamePasswordLoginService: UsernamePasswordLoginService,
                private loginHelpService: LoginHelpService,
                @Inject('$location') private $location: ng.ILocationService,
                @Inject('$timeout') private $timeout: ng.ITimeoutService) {
    }

    ngOnInit() {
        if (this.authenticationMethods.length === 1) {
            // Single login
            let authenticationMethod = this.authenticationMethods[0];
            if (authenticationMethod.isExternal()) {
                this.loginService.redirectLogin(authenticationMethod, this.$location.search().targetURL);
            } else {
                this._showSubmitButton = true;
                this.showActionsBar = true;
                this._showBackButton = false;
                this.selectedTab = 1;
                this._isDualLogin = false;
                this.$timeout(() => {
                    let element = document.getElementById('LoginUserName');
                    element.focus();
                }, 300);
                this._selectedAuthenticationMethod = authenticationMethod;

                // Save the current URL as a state to return to
                this.loginService.handleLogin();

            }
        } else {
            this._isDualLogin = true;
            this.$timeout(() => {
                // document.getElementById('test').focus();
                let element = document.querySelector('prm-login md-list-item button');
                element.focus();
            }, 300);
        }
    }

    get selectedTab() {
        return this._selectedTab;
    }

    set selectedTab(selectedTab) {
        this._selectedTab = selectedTab;
    }

    get selectedAuthenticationMethod() {
        return this._selectedAuthenticationMethod;
    }

    set selectedAuthenticationMethod(selectedAuthenticationMethod) {
        this._selectedAuthenticationMethod = selectedAuthenticationMethod;
    }

    get showError() {
        if (this._errorLabel) {
            return 1;
        } else {
            return 0;
        }
    }

    public handleLoginClick(authenticationMethod: AuthenticationMethod) {
        if (authenticationMethod.isExternal()) {
            this.loginService.redirectLogin(authenticationMethod);
        } else {
            this._showSubmitButton = true;
            this.showActionsBar = true;
            this._showBackButton = true;
            this.selectedTab = 1;
            this._selectedAuthenticationMethod = authenticationMethod;
        }
    }

    public showSubmitButton() {
        return this._showSubmitButton;
    }

    public showBackButton() {
        return this._showBackButton;
    }

    public handleBackButtonClick() {
        this._showSubmitButton = false;
        this.showActionsBar = true;
        this._showBackButton = false;
        this.selectedTab = 0;
    }

    public cancelLogin() {
        if (this.isUnionCatalogLogin()) {
            this.returnToUnionCatalogNZView();
        }
        this.loginService.removeBackgroundDarkClass();
        this.loginService.clearSavedState();
        this.$mdDialog.cancel();
        document.querySelector('#signInBtn').focus();
    }

    public getLoginTitleForDisplay() {
        if (this._isDualLogin) {
            return 'login.dual.title';
        } else {
            return 'login.title';
        }
    }

    public getErrorForDisplay() {
        return this._errorLabel;
    }

    public login() {
        let username = this.username;
        let password = this.password;
        if (!username && !password) {
            this._errorLabel = 'nui.login.error.missing_fields';
            document.getElementById('LoginUserName').focus();
            document.getElementById('LoginUserName').setAttribute("aria-invalid", "true");
            document.getElementById('LoginPassword').setAttribute("aria-invalid", "true");
        } else if (!username || !password) {
            this._errorLabel = 'nui.login.error.missing_field';
            document.getElementById('LoginUserName').setAttribute("aria-invalid", "true");
            document.getElementById('LoginPassword').setAttribute("aria-invalid", "true");

            if (!username) {
                this._errorField = 'login.userid';
                document.getElementById('LoginUserName').focus();
                document.getElementById('LoginUserName').setAttribute("aria-invalid", "true");
                document.getElementById('LoginPassword').setAttribute("aria-invalid", "false");
            } else if (!password) {
                this._errorField = 'login.password';
                document.getElementById('LoginPassword').focus();
                document.getElementById('LoginPassword').setAttribute("aria-invalid", "true");
                document.getElementById('LoginUserName').setAttribute("aria-invalid", "false");
            } else {
                this._errorField = '';
            }
        } else {
            // Both username and password exist, proceed to login
            this._errorLabel = null;
            let oldJwt = this.jwtUtilService.getDecodedToken().user;
            let authenticationProfileName = this._selectedAuthenticationMethod.profileName;
            let targetUrl = this._selectedAuthenticationMethod.authenticationSystem === 'ALMA' ? this.loginService.getToUrl() : '';

            this.usernamePasswordLoginService.login(username, password, authenticationProfileName, targetUrl).then((redirectUrl) => {
                // Login success
                this.usernamePasswordLoginService.copyFavoritesRecordsThatWereSavedForGuest(oldJwt);
                this.usernamePasswordLoginService.changeSearchHistorylocalForageKey(oldJwt);
                this.usernamePasswordLoginService.combineRecentScopeToSession(oldJwt);
                this.personalizeResultsButtonService.promise = this.personalizeResultsButtonService.updatePersonalization(this.$stateParams['vid']);

                //alma change password redirect
                if (redirectUrl) {
                    try {
                        redirectUrl = this.handleDecodeEncode(redirectUrl);
                        this.loginService.redirectToTargetURL(redirectUrl);
                    } catch (e) {
                        console.error(e);
                    }
                } else if (this.isStandAlone) {
                    this.loginService.redirectToTargetURL();
                } else {
                    this.$mdDialog.hide();
                    this.loginService.removeBackgroundDarkClass();

                    if (this.loginService.toState) {
                        this.loginService.loadSavedState();
                    } else if (this.$state.current.name === STATE_NAMES.SEARCH) {
                        this.$state.go(STATE_NAMES.SEARCH, {}, {reload: true});
                    }

                    let decodedJwt = this.jwtUtilService.getDecodedToken();
                    if ((decodedJwt.language !== '') && (decodedJwt.language !== this.i18nService.getLanguage())) {
                        this.i18nService.setLanguage(decodedJwt.language).then(() => {
                            this.$state.go(this.$state.current, {}, {reload: true});
                        });

                    }
                }

            }, (response) => {
                // Login failure
                this._errorLabel = 'login.error.message';
                document.getElementById('LoginUserName').focus();
                document.getElementById('LoginUserName').setAttribute("aria-invalid", "true");
                document.getElementById('LoginPassword').setAttribute("aria-invalid", "true");
            });
        }
    }

    // This function sets the field to be displayed in the error message when
    // a required field is missing
    public getPlaceHolders() {
        return {idx_0: `{{"${this._errorField}" | translate}}`};
    }

    get displaySigninHelp() {
        return this.loginHelpService.displaySigninHelp;
    }

    public standAlone() {
        return this.isStandAlone;
    }


    // decodes the url prom the login process 3 times and then encodes it once
    private handleDecodeEncode(url) {
        if (!url) return;
        let urlArr = url.split('backUrl=', 2);
        if (urlArr.length === 2) {
            let backUrl = window.location.href;
            if (this.loginService._toState.name === 'account') {
                backUrl = this.generteBackUrlForAccunt(backUrl);
            }
            if (!urlArr[1]) {
                urlArr[1] = backUrl;
            }
            //if there are other parameters after the backUrl
            else if (urlArr[1].includes('&')) {
                let params = urlArr[1].split('&', 2);
                if (!urlArr[0].endsWith('?')) {
                    urlArr[0] += '&';
                }
                urlArr[0] += params[1] + '&';
                urlArr[1] = backUrl;
            }
            //decode & encode
            urlArr[1] = decodeURIComponent(decodeURIComponent(decodeURIComponent(urlArr[1])));
            urlArr[1] = encodeURI(urlArr[1]);//encode parameters
            return urlArr[0] + 'backUrl=' + encodeURIComponent(urlArr[1]);

        } else return url;
    }

    private generteBackUrlForAccunt(backUrl) {
        let toState = this.loginService._toState.name;
        let hostname = window.location.origin;
        let product = window.location.pathname.substr(0, window.location.pathname.lastIndexOf('/') + 1);
        let params = '?' + this.serialize(this.loginService._toParams);
        let url = hostname + product + toState + params;
        return url;
    }

    private serialize(obj) {
        let str = [];
        for (let p in obj)
            if (obj.hasOwnProperty(p)) {
                str.push(p + "=" + encodeURIComponent(obj[p]));
            }
        return str.join("&");
    }

    public getProfileLinkForDisplay(index) {
        let linkNumber = index + 1;
        return "parallel.login.link" + linkNumber;
    }

    public getProfileLinkDescriptionForDisplay(index) {
        let linkNumber = index + 1;
        return "parallel.login.description" + linkNumber;
    }

    public isUnionCatalogLogin() {
        return this.loginService.isUnionCatalogLogin();
    }

    private returnToUnionCatalogNZView() {
        this.loginService.returnToUnionCatalogNZView();
    }

    public keydownSupportGustLogin(e) {
        let keyCodes = this.KEY_CODE;

        if (e.keyCode === keyCodes.ESCAPE) {
            e.preventDefault();
            return document.querySelector('#signInBtn').focus();
        }

    }

    private isLoginState() {
        return this.$state.current.name === STATE_NAMES.LOGIN;
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/security/login/login.directive.ts